import React from 'react';

import { Flex } from '@chakra-ui/react';

function Assets() {
  return <Flex data-id="ea2039cfe514">Assets</Flex>
}

export default Assets;
